"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 입력값을 비우는 버튼. 입력 필드 안에 놓이므로 아이콘 버튼 중 가장 작은 크기를 쓴다.
 */
let ClearButton = class ClearButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.ariaLabel = '';
        this.tooltipPlacement = 'bottom-start';
        this.disabled = false;
    }
    render() {
        return (0, icon_button_utils_1.renderIconAction)({
            icon: icon_names_1.ICON_NAMES.CLOSE,
            ariaLabel: this.ariaLabel,
            tooltipPlacement: this.tooltipPlacement,
            disabled: this.disabled,
        });
    }
};
ClearButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    (0, lit_1.css) `
      :host {
        --icon-button-size: var(--size-16);
        --icon-button-border-radius: var(--radius-full);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], ClearButton.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'tooltip-placement' })
], ClearButton.prototype, "tooltipPlacement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ClearButton.prototype, "disabled", void 0);
ClearButton = __decorate([
    (0, decorators_js_1.customElement)('mm-clear-button')
], ClearButton);
exports.ClearButton = ClearButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xlYXItYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2xlYXItYnV0dG9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFxQztBQUNyQyxxREFBMkQ7QUFJM0Qsb0VBQWdFO0FBQ2hFLDJGQUFxRjtBQUNyRix5RkFBb0Y7QUFDcEYsK0RBQXlEO0FBRXpEOztHQUVHO0FBRUksSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBQXBDOztRQVdnRCxjQUFTLEdBQUcsRUFBRSxDQUFBO1FBRW5FLHFCQUFnQixHQUFxQixjQUFjLENBQUE7UUFDdEIsYUFBUSxHQUFHLEtBQUssQ0FBQTtJQVUvQyxDQUFDO0lBUkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxvQ0FBZ0IsRUFBQztZQUN0QixJQUFJLEVBQUUsdUJBQVUsQ0FBQyxLQUFLO1lBQ3RCLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUztZQUN6QixnQkFBZ0IsRUFBRSxJQUFJLENBQUMsZ0JBQWdCO1lBQ3ZDLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtTQUN4QixDQUFDLENBQUE7SUFDSixDQUFDOztBQXRCTSxrQkFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCxxQ0FBZ0I7SUFDaEIsSUFBQSxTQUFHLEVBQUE7Ozs7O0tBS0Y7Q0FDRixDQUFBO0FBQ29EO0lBQXBELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxDQUFDOzhDQUFlO0FBRW5FO0lBREMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsbUJBQW1CLEVBQUUsQ0FBQztxREFDUjtBQUN0QjtJQUE1QixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLENBQUM7NkNBQWlCO0FBZGxDLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0F3QnZCO0FBeEJZLGtDQUFXIn0=